// Arma el objeto que muestra la card de EstablecimientosSeleccionados a partir del establecimiento
// (GET /establecimientos/:id o la fila de la lista) o, si no llegó, del fallback disponible.
export const normalizeEstablishmentCardData = (establishment?: any, fallback?: any) => {
    if (!establishment && !fallback?.id) return null;

    const source = establishment || fallback;
    const localidad = source?.direccion?.localidad || source?.localidad || {};

    return {
        id: source?.id || fallback?.id,
        nombre: source?.nombre || fallback?.nombre || 'Establecimiento seleccionado',
        // N° de establecimiento que muestra la card (SMP-669)
        codigoSRT: source?.codigoSRT ?? fallback?.codigoSRT ?? null,
        localidad,
        postalCode: localidad?.codigoPostal || source?.postalCode || 'N/A',
        estado: source?.estado,
        direccion: {
            calle: source?.direccion?.calle ?? source?.calle ?? '',
            altura: source?.direccion?.altura ?? source?.altura ?? '',
            departamento: source?.direccion?.departamento ?? source?.departamento ?? null
        }
    };
};
